import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appCacheBuster]',
})
export class CacheBusterDirective implements OnChanges {
  // USE WHEN IMAGE is rendered in AG GRID
  @Input() appCacheBuster!: string; // Input to receive the image URL
  private cacheBuster: number;

  constructor(private el: ElementRef) {
    this.cacheBuster = new Date().getTime(); // Generate a cache-busting value
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appCacheBuster']) {
      const imageUrl = changes['appCacheBuster'].currentValue;
      const imageUrlWithCacheBuster = `${imageUrl}?cb=${this.cacheBuster}`;
      this.el.nativeElement.src = imageUrlWithCacheBuster;
    }
  }
}
